import { Utilities_Types } from './Utilities.frontend.types'

export namespace Cartonization_Types {
  /**
   * Enumeration with the options for cartonization context.
   */
  export enum e_cartonization_context {
    Order = 0,
    Shipment = 1
  }
  /**
   * Interface representing the schema for cartonization configuration.
   */
  export interface i_cartonization_configuration {
    strategy?: { use_volume?: boolean, use_dimensions?: boolean, use_weight?: boolean };
    palletization?: { use_tie_high?: boolean, exclude_packagings?: number[], allow_packagings?: number[] };
    grouping?: { order?: boolean, shipment?: boolean, material?: boolean, packaging?: boolean };
    wave_release?: { exclude_full_license_plate_picks?: boolean, nest_shipping_containers?: boolean };
    restrictions?: { allow_packaging_ids?: number[], exclude_packaging_ids?: number[], allow_container_type_ids?: number[], exclude_container_type_ids?: number[], allow_container_type_category_ids?: number[], exclude_container_type_category_ids?: number[] };
    use_ready_to_ship?: boolean;
    type?: number;
  }
  /**
   * Represents cartonization containers.
   */
  export interface i_container {
    container_id: number;
    parent_id: number;
    container_type_id: number;
    length: number;
    width: number;
    height: number;
    dimensions_uom_id: number;
    volume_uom_id: number;
    weight: number;
    weight_uom_id: number;
    inventory_measurement_unit_id: number;
    existing_container_ids: number[];
    remaining_weight: number;
    remaining_volume: number;
    remaining_quantity_capacity: number;
    quantities: $frontendTypes.Cartonization.i_quantity[];
    shipment_id?: number;
  }
  /**
   * Represents cartonization quantities.
   */
  export interface i_quantity {
    order_id: number;
    line_number: number;
    material_id: number;
    packaging_id: number;
    amount: number;
  }
}

export namespace $frontendTypes {
  export import Utilities =  Utilities_Types;
  export import Cartonization = Cartonization_Types;
}




